export default __webpack_public_path__ + "static/media/RM-logo.93c0c4c5.png";